import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../login/login.service';
import { SharedService } from '../services/shared.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})


export class ChangePasswordComponent {
  hide: any = {};
  changePasswordForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _loginService: LoginService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private _sharedService: SharedService,
  ) { 
    this.changePasswordForm = this._fb.group({
      current_password: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
      confirm_password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
    })
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    if(this.changePasswordForm.valid) {
      const formValue = this.changePasswordForm.value;
      if(formValue['password'] != formValue['confirm_password']) {
        this.changePasswordForm.controls['confirm_password'].setErrors({
          mismatch: true
        })
        // this.changePasswordForm.controls['confirm_password'].updateValueAndValidity();
        return
      } else {
        this.changePasswordForm.controls['confirm_password'].setErrors(null);
        this.changePasswordForm.controls['confirm_password'].updateValueAndValidity();
      }
      this._loginService.changePassword(formValue).subscribe((response: any) => {
        if(response['success']) {
          this.onClose()
          this._sharedService.openSnackBar(response['message']);
        }
      }, (error) => {
        if(error.status === 400) {
          this._sharedService.openSnackBar(error.error['message']);
        }
        if(error.status === 401) {
          this.onClose();
        }
      })
    } else {
      Object.values(this.changePasswordForm.controls).forEach(control => {
				if (control.invalid) {
					control.markAsDirty();
					control.updateValueAndValidity({ onlySelf: true });
				}
			});
    }
  }
}
